
import * as mediavaletRuntime$F0cbjH2w9J_ctrQqIdlBCXbDsMnD74obW_XGuUtbLM0 from '/Users/cdm/code/turbo/playaresorts/node_modules/@nuxt/image/dist/runtime/providers/imgix'
import * as ipxRuntime$Yc_458wO97Rz0hBpSAQ7Yk_OwnhTorE8t8yJ1Bh5_45J8_0 from '/Users/cdm/code/turbo/playaresorts/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['mediavalet']: { provider: mediavaletRuntime$F0cbjH2w9J_ctrQqIdlBCXbDsMnD74obW_XGuUtbLM0, defaults: {"baseURL":"https://playa-media.imgix.net"} },
  ['ipx']: { provider: ipxRuntime$Yc_458wO97Rz0hBpSAQ7Yk_OwnhTorE8t8yJ1Bh5_45J8_0, defaults: {} }
}
        